// extracted by mini-css-extract-plugin
export default {"calendar-component":"styles_calendar-component__v3Wba","month":"styles_month__s9Evf"};